/**
 * @flow
 * @relayHash 355e155c1d1030b94d13fc98a269d474
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetConfigInput = {
  userId: string,
  widgetId: string,
  config: string,
  clientMutationId?: ?string,
};
export type UpdateWidgetConfigMutationVariables = {|
  input: UpdateWidgetConfigInput
|};
export type UpdateWidgetConfigMutationResponse = {|
  +updateWidgetConfig: ?{|
    +widget: ?{|
      +config: ?string
    |}
  |}
|};
export type UpdateWidgetConfigMutation = {|
  variables: UpdateWidgetConfigMutationVariables,
  response: UpdateWidgetConfigMutationResponse,
|};
*/


/*
mutation UpdateWidgetConfigMutation(
  $input: UpdateWidgetConfigInput!
) {
  updateWidgetConfig(input: $input) {
    widget {
      config
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetConfigInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateWidgetConfigInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "config",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UpdateWidgetConfigMutation",
  "id": null,
  "text": "mutation UpdateWidgetConfigMutation(\n  $input: UpdateWidgetConfigInput!\n) {\n  updateWidgetConfig(input: $input) {\n    widget {\n      config\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateWidgetConfigMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetConfig",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetConfigPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateWidgetConfigMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetConfig",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetConfigPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2127f87672065f25d565b3bcb954f5e9';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/UpdateWidgetConfigMutation.graphql.js